import classNames from 'classnames';
import * as React from 'react';
import { getShortcutColorVariant, mapSectionItems } from '../Utils/LinkListSectionUtils';
import type { LinkListSectionPlainViewModel } from '../ViewModel/LinkListSectionPlainViewModel.csharp';
import { useTheme } from '~/Features/Layouts/Theme/Context/ThemeContextProvider';
import { LinkList } from '~/Partials/LinkList/LinkList';
import styles from './Shared/Styles/LinkListSection.module.css';

export const LinkListSectionPlainContent: React.FC<LinkListSectionPlainViewModel> = props => {
    const { title, description, variant, columnsLayout, items } = props;

    const theme = useTheme();

    const showHeader = title || description;

    return (
        <div className={classNames(styles[`Variant--${variant}`], styles[`Variant--${columnsLayout}`])}>
            {showHeader && (
                <div className={styles.Header}>
                    {title && <h2 className={styles.Title}>{title}</h2>}
                    {description && <p className={styles.Description}>{description}</p>}
                </div>
            )}
            <LinkList
                linkSize="large"
                links={mapSectionItems(items)}
                linkVariant={getShortcutColorVariant(variant)}
                itemWrapperClassName={styles.LinkWrapper}
                className={styles.List}
                theme={{ ...theme, withBoxShadow: false }}
            />
        </div>
    );
};
